import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [seeding, setSeeding] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  useEffect(() => {
    // Seed data on first load
    const seedData = async () => {
      try {
        setSeeding(true);
        await axios.post(`${API}/seed`);
        setSeeding(false);
      } catch (error) {
        console.log('Seed check complete');
        setSeeding(false);
      }
    };
    seedData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      toast.success('Welcome back!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }
    
    setIsLoading(false);
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 login-bg"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1663563624897-de8972d7ce93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxhbWVyaWNhbiUyMGZvb3RiYWxsJTIwc3RhZGl1bSUyMG5pZ2h0JTIwbGlnaHRzfGVufDB8fHx8MTc2OTUzOTcwM3ww&ixlib=rb-4.1.0&q=85')`
      }}
    >
      <div className="relative z-10 w-full max-w-md">
        <div className="bg-white border border-[#E2E8F0] rounded-xl p-8 shadow-xl animate-fadeIn">
          {/* Logo / Header */}
          <div className="text-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_6a45feef-1fdd-42ef-b734-4d0c936a20ae/artifacts/rnct6wzk_players-health-lockup-color%20%281%29.png" 
              alt="Players Health" 
              className="h-12 w-auto mx-auto mb-4"
            />
            <p className="text-[#475569] text-sm">
              Division I FBS/FCS Insurance & Risk Management
            </p>
          </div>

          {seeding && (
            <div className="mb-4 p-3 bg-[#F1F5F9] rounded-md text-center">
              <p className="text-[#007AFF] text-sm animate-pulse">Initializing database...</p>
            </div>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-[#475569] text-sm uppercase tracking-wider font-medium">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="bg-[#F8FAFC] border-[#E2E8F0] text-[#0F172A] placeholder:text-[#94A3B8] focus:ring-2 focus:ring-[#007AFF] focus:border-transparent h-12"
                data-testid="login-email-input"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#475569] text-sm uppercase tracking-wider font-medium">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="bg-[#F8FAFC] border-[#E2E8F0] text-[#0F172A] placeholder:text-[#94A3B8] focus:ring-2 focus:ring-[#007AFF] focus:border-transparent h-12"
                data-testid="login-password-input"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading || seeding}
              className="w-full h-12 bg-[#007AFF] hover:bg-[#0066CC] text-white font-bold uppercase tracking-wide shadow-lg hover:shadow-xl transition-all duration-300"
              data-testid="login-submit-btn"
            >
              {isLoading ? 'Signing In...' : 'Sign In'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
